import myimg from "./assets/roy.png";

const meta = {
    title: "Roy Nakakawa",
    description: "I can help you with your crypto project",
};

const introdata = {
    name: "Roy Nakakawa",
    animated: {
        first: "I'm thrilled by Blockchain",
        second: "I want to decentralize the money",
        third: "I have a big passion for Crypto",
    },
    speech1: "Have you heard 'crypto' or 'blockchain' but don't know where to start?",
    speech2: "I can help you !!",
    speech3: "I've been delivering crypto projects for about 6 years",
};

const socialprofils = {
    github: "https://github.com/roynakakawa",
    linkedin: "https://www.linkedin.com/in/miguel-r-nakakawa/",
    twitter: "https://twitter.com/roynakakawa",
};

const dataabout = {
    aboutme: "I'm Roy, an electric engineer living in Mexico. I usually spend my time reading and having fun automating boring things. I've been involved in the Crypto ecosystem for about 6 years. I really believe that Blockchain can change our current understanding of how money works and empower individuals over centralized authorities",
};

const skills = [{
    name: "Delivery",
    value: 90,
},
{
    name: "Agile",
    value: 85,
},
{
    name: "Blockchain / Crypto",
    value: 85,
},
{
    name: "DeFi",
    value: 80,
},
{
    name: "dApps",
    value: 80,
},
{
    name: "Javascript",
    value: 50,
},
{
    name: "React",
    value: 45,
},
];

export {
    meta,
    introdata,
    myimg,
    socialprofils,
    dataabout,
    skills,
};